import { IGlobalResponse, IRequest, IResultHandleValue } from '@/services/typings';
import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  CreateAxiosDefaults,
  InternalAxiosRequestConfig,
} from 'axios';

class Request implements IRequest {
  private readonly axiosInstance: AxiosInstance;
  private readonly config: CreateAxiosDefaults = {
    // 请求超时时间
    timeout: 30000,
    // 请求公共路径
    baseURL: '/',
    // 公共请求头
    headers: {
      'x-requested-with': 'XMLHttpRequest',
    },
    withCredentials: true,
  };

  constructor(config: CreateAxiosDefaults = {}) {
    this.config = {
      ...this.config,
      ...config,
    };
    this.axiosInstance = axios.create(this.config);
    this.interceptors();
  }

  /**
   * @description 公共请求拦截器
   */
  private interceptors() {
    // 请求拦截
    this.axiosInstance.interceptors.request.use(
      (config: InternalAxiosRequestConfig) => {
        const accessToken =  localStorage.getItem("token");
        if (accessToken) {
          config.headers.accessToken = `${accessToken}`;
        }
        return config;
      },
      (error: any) => {
        return Promise.reject(error);
      },
    );
    // 响应拦截
    this.axiosInstance.interceptors.response.use(
      (response: AxiosResponse) => {
        console.log('response',response)
        return response.data;
      },
      (error: any) => {
        return Promise.reject(error.response);
      },
    );
  }

  /**
   * @description 接口响应处理
   */
  private resultHandle<R = {}>(res: Promise<IGlobalResponse<R>>) {
    return new Promise<IResultHandleValue<R>>((resolve) => {
      res
        .then((res) => {
          resolve(res as any);
        })
        .catch((err) => {
          console.log('error',err?.data)
          if(err?.data.status==10010 ||err?.data.status==10012){
            //token过期清空token并刷新页面（走未登录模式接口）
            localStorage.removeItem('token')
            window.location.reload();
          }
          resolve([undefined as any, err]);
        });
    });
  }

  post<R = {}>(url: string, data?: Record<string, any>, config?: AxiosRequestConfig) {
    return this.resultHandle<R>(
      this.axiosInstance.post<any, IGlobalResponse<R>>(url, data, config),
    );
  }

  get<R = {}>(url: string, params?: Record<string, any>, config?: AxiosRequestConfig) {
    return this.resultHandle<R>(
      this.axiosInstance.get<any, IGlobalResponse<R>>(url, {
        params,
        ...config,
      }),
    );
  }

  request<R = {}>(config: AxiosRequestConfig) {
    return this.resultHandle<R>(this.axiosInstance.request<any, IGlobalResponse<R>>(config));
  }
}

const request = new Request();

export default request;
